export const ID_ESTADO_ENVIADO = 1
export const ID_ESTADO_ENTREGADO = 2
export const ID_ESTADO_ENTREGA_OBSERVADA = 3
export const ID_ESTADO_PERCEPCIONES_OK = 4
export const ID_ESTADO_PERCEPCIONES_NO_OK = 5
export const ID_ESTADO_EN_ESPERA = 6
